let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6ZTZI")).then(() => parcelRequire('c6FnB'));